/**
 * User: WangMeng
 * Date: 2018-07-13
 * Time: 10:09
 * Desc: 财务舞弊，财务风险评分公用
 */
import './scorePana.scss';
import React from 'react';
import { Spin } from 'antd';
import { isNotEmpty } from '../../../../utils/util';
import { createScoreRadarOption } from '../../../../utils/chart';
import Gauge from '../../../common/gauge/Gauge';
import NoData from '../../../common/noData/NoData';
import BBDRadar from '../../../common/echarts/BBDRadar';

export default function ScorePane({ loading, score, radarData }) {
    const radarOption = createScoreRadarOption(radarData);

    return (
        <div className="double-charts-layout">
            {
                loading ?
                    <Spin /> :
                    <div>
                        <div className="chart">
                            {
                                isNotEmpty(score) ?
                                    <Gauge exponent={score} /> : <NoData />
                            }
                        </div>
                        <div className="chart">
                            {
                                isNotEmpty(radarOption) ?
                                    <BBDRadar option={radarOption} /> : <NoData />
                            }
                        </div>
                    </div>
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/scorePane/ScorePane.jsx